import React from 'react'
import LeaguesRenameRow from './LeaguesRenameRow'
import useSessionSaver from '../../hooks/useSessionSaver'


const LeaguesRenameList = () => {
  const { mergedLeagues } = useSessionSaver()

  return (
    <div className={'cls-lr-container'}>
      <div className={'cls-lr-table-container'}>
        <div className={'cls-lr-table-wrapper'}>
          <table className={'cls-lr-table'}>
            <thead className={'cls-lr-thead'}>
              <tr className={'cls-lr-thead-row'}>
                <th className={'cls-lr-thead-cell'}>#</th>
                <th className={'cls-lr-thead-cell'}>
                  {window.I18n.t('key_settings.table.league_name')}
                </th>
                <th className={'cls-lr-thead-cell'}>
                  {window.I18n.t('clone_leagues_sessions.general.first_round')}
                </th>
                <th className={'cls-lr-thead-cell'}>
                  {window.I18n.t('clone_leagues_sessions.general.last_round')}
                </th>
                <th className={'cls-lr-thead-cell'}>
                  {window.I18n.t('clone_leagues_sessions.leagues_rename.edit_name')}
                </th>
                <th className={'cls-lr-thead-cell'}>
                  {window.I18n.t('clone_leagues_sessions.general.type')}
                </th>
              </tr>
            </thead>
            <tbody>
            {/* Rows */}
            {Object.entries(mergedLeagues).map(([ leagueId, league ], index) => (
              <LeaguesRenameRow key={leagueId} index={index} leagueId={leagueId} league={league} />
            ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default LeaguesRenameList
